import * as React from "react";

const kDefaultHeight = "24";
const kDefaultWidth = "24";

export interface ILoadingIconProps {
  className?: string;
  height?: string;
  width?: string;
}

export const LoadingIcon = (props: ILoadingIconProps) => {
  const className = props.className ? props.className : "";
  const height = props.height ? props.height : kDefaultHeight;
  const width = props.width ? props.width : kDefaultWidth;

  return(
    <svg
      className={className}
      height={height}
      viewBox={`0 0 384 384`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-64,-64)">
        <path d="m 296,186.7 c 7.7,4.4 17.4,1.8 21.9,-5.9 l 40,-69.3 c 4.4,-7.7 1.8,-17.4 -5.9,-21.9 -7.7,-4.4 -17.4,-1.8 -21.9,5.9 l -40,69.3 c -4.4,7.7 -1.8,17.5 5.9,21.9 z" />
        <path d="m 325.3,216 c 4.4,7.7 14.2,10.3 21.9,5.9 l 69.3,-40 c 7.7,-4.4 10.3,-14.2 5.9,-21.9 -4.4,-7.7 -14.2,-10.3 -21.9,-5.9 l -69.3,40 c -7.7,4.5 -10.3,14.2 -5.9,21.9 z" />
        <path d="m 432,240 -80,0 c -8.8,0 -16,7.2 -16,16 0,8.8 7.2,16 16,16 l 80,0 c 8.8,0 16,-7.2 16,-16 0,-8.8 -7.2,-16 -16,-16 z"  />
        <path d="m 416.4,330.1 -69.3,-40 c -7.7,-4.4 -17.4,-1.8 -21.9,5.9 -4.4,7.7 -1.8,17.4 5.9,21.9 l 69.3,40 c 7.7,4.4 17.4,1.8 21.9,-5.9 4.4,-7.7 1.8,-17.4 -5.9,-21.9 z" />
        <path d="m 317.9,331.1 c -4.4,-7.7 -14.2,-10.3 -21.9,-5.9 -7.7,4.4 -10.3,14.2 -5.9,21.9 l 40,69.3 c 4.4,7.7 14.2,10.3 21.9,5.9 7.7,-4.4 10.3,-14.2 5.9,-21.9 l -40,-69.3 z" />
        <path d="m 256,336 c -8.8,0 -16,7.2 -16,16 l 0,80 c 0,8.8 7.2,16 16,16 8.8,0 16,-7.2 16,-16 l 0,-80 c 0,-8.8 -7.2,-16 -16,-16 z" />
        <path d="m 216,325.3 c -7.7,-4.4 -17.4,-1.8 -21.9,5.9 l -40,69.3 c -4.4,7.7 -1.8,17.4 5.9,21.9 7.7,4.4 17.4,1.8 21.9,-5.9 l 40,-69.3 c 4.4,-7.7 1.8,-17.5 -5.9,-21.9 z" />
        <path d="m 186.7,296 c -4.4,-7.7 -14.2,-10.3 -21.9,-5.9 l -69.3,40 c -7.7,4.4 -10.3,14.2 -5.9,21.9 4.4,7.7 14.2,10.3 21.9,5.9 l 69.3,-40 c 7.7,-4.5 10.3,-14.2 5.9,-21.9 z" />
        <path d="m 176,256 c 0,-8.8 -7.2,-16 -16,-16 l -80,0 c -8.8,0 -16,7.2 -16,16 0,8.8 7.2,16 16,16 l 80,0 c 8.8,0 16,-7.2 16,-16 z" />
        <path d="m 95.6,181.9 69.3,40 c 7.7,4.4 17.4,1.8 21.9,-5.9 4.5,-7.7 1.8,-17.4 -5.9,-21.9 l -69.3,-40 c -7.7,-4.4 -17.4,-1.8 -21.9,5.9 -4.4,7.7 -1.8,17.4 5.9,21.9 z" />
        <path d="m 181.9,95.6 c -4.4,-7.7 -14.2,-10.3 -21.9,-5.9 -7.7,4.4 -10.3,14.2 -5.9,21.9 l 40,69.3 c 4.4,7.7 14.2,10.3 21.9,5.9 7.7,-4.4 10.3,-14.2 5.9,-21.9 l -40,-69.3 z" />
        <path d="m 256,64 c -8.8,0 -16,7.2 -16,16 l 0,80 c 0,8.8 7.2,16 16,16 8.8,0 16,-7.2 16,-16 l 0,-80 c 0,-8.8 -7.2,-16 -16,-16 z" />
      </g>
    </svg>
  );
};
